const TaskStatus = Object.freeze({
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  COMPLETE: 'complete',
  ON_HOLD: 'on_hold'
})

export default TaskStatus